import React from "react";

const StatusFilterTabs = ({ theme, isRTL, t, filterStatus, setFilterStatus }) => {
  return (
    <div
      className="nx-tabs-scroll"
      style={{
        display: "flex",
        gap: "10px",
        flexWrap: "wrap",
        flexDirection: isRTL ? "row" : "row",
      }}
    >
      <button
        onClick={() => setFilterStatus("all")}
        style={{
          padding: "8px 16px",
          borderRadius: "10px",
          border: "none",
          background:
            filterStatus === "all"
              ? "linear-gradient(135deg, #2e7cba, #2e7cba)"
              : theme === "dark"
                ? "rgba(255,255,255,0.08)"
                : "rgba(0,0,0,0.05)",
          color:
            filterStatus === "all"
              ? "#fff"
              : theme === "dark"
                ? "#fff"
                : "#374151",
          fontWeight: "600",
          cursor: "pointer",
          transition: "all 0.3s ease",
        }}
      >
        {t.all}
      </button>

      <button
        onClick={() => setFilterStatus("present")}
        style={{
          padding: "8px 16px",
          borderRadius: "10px",
          border: "none",
          background:
            filterStatus === "present"
              ? "linear-gradient(135deg, #10b981, #059669)"
              : theme === "dark"
                ? "rgba(255,255,255,0.08)"
                : "rgba(0,0,0,0.05)",
          color:
            filterStatus === "present"
              ? "#fff"
              : theme === "dark"
                ? "#fff"
                : "#374151",
          fontWeight: "600",
          cursor: "pointer",
          transition: "all 0.3s ease",
        }}
      >
        {t.present}
      </button>

      <button
        onClick={() => setFilterStatus("absent")}
        style={{
          padding: "8px 16px",
          borderRadius: "10px",
          border: "none",
          background:
            filterStatus === "absent"
              ? "linear-gradient(135deg, #ef4444, #dc2626)"
              : theme === "dark"
                ? "rgba(255,255,255,0.08)"
                : "rgba(0,0,0,0.05)",
          color:
            filterStatus === "absent"
              ? "#fff"
              : theme === "dark"
                ? "#fff"
                : "#374151",
          fontWeight: "600",
          cursor: "pointer",
          transition: "all 0.3s ease",
        }}
      >
        {t.absent}
      </button>

      <button
        onClick={() => setFilterStatus("late")}
        style={{
          padding: "8px 16px",
          borderRadius: "10px",
          border: "none",
          background:
            filterStatus === "late"
              ? "linear-gradient(135deg, #f59e0b, #d97706)"
              : theme === "dark"
                ? "rgba(255,255,255,0.08)"
                : "rgba(0,0,0,0.05)",
          color:
            filterStatus === "late"
              ? "#fff"
              : theme === "dark"
                ? "#fff"
                : "#374151",
          fontWeight: "600",
          cursor: "pointer",
          transition: "all 0.3s ease",
        }}
      >
        {t.late}
      </button>

      <button
        onClick={() => setFilterStatus("onLeave")}
        style={{
          padding: "8px 16px",
          borderRadius: "10px",
          border: "none",
          background:
            filterStatus === "onLeave"
              ? "linear-gradient(135deg, #6366f1, #818cf8)"
              : theme === "dark"
                ? "rgba(255,255,255,0.08)"
                : "rgba(0,0,0,0.05)",
          color:
            filterStatus === "onLeave"
              ? "#fff"
              : theme === "dark"
                ? "#fff"
                : "#374151",
          fontWeight: "600",
          cursor: "pointer",
          transition: "all 0.3s ease",
        }}
      >
        {t.onLeave}
      </button>
    </div>
  );
};

export default StatusFilterTabs;